/**
* Tiny logger.
*
* `debug` and `warn` run only in the dev build: Webpack replaces `__DEV__` with `true` or `false`
* via DefinePlugin (in `configs/tasks/vue/webpack.dev.js` and `webpack.prod.js` respectively),
* and the minifier subsequently removes these branches entirely from the production bundle—
* including the log messages themselves.
*
* `error` is always output, as errors should be visible in production as well.
*
* In unit tests, `__DEV__` is provided by `globals` in `jest.config.js`.
*/
export function debug(message, ...details) {
    if (__DEV__) {
        console.log(message, ...details);
    }
}
export function warn(message, ...details) {
    if (__DEV__) {
        console.info(message, ...details);
    }
}
export function error(message, ...details) {
    console.error(message, ...details);
}
